<div (click)="$event.stopPropagation(); $event.preventDefault(); toggleDropdown()" [ngClass]="{ open: isDropdownOpen }" class="nav-item language-selector">
  <div class="dropdown-toggle">
    {{ currentLanguage }}
    @if (!isDropdownOpen) {
      <app-icon [cssStyle]="{ 'margin-top': '2px' }" [iconName]="openAbove ? 'chevron-up' : 'chevron-down'" [planeIcon]="true" color="var(--slate-gray)" size="16px"></app-icon>
    }
    @if (isDropdownOpen) {
      <app-icon [cssStyle]="{ 'margin-top': '2px' }" [iconName]="openAbove ? 'chevron-down' : 'chevron-up'" [planeIcon]="true" color="var(--slate-gray)" size="16px"></app-icon>
    }
  </div>
  @if (isDropdownOpen) {
    <div [ngClass]="{ above: openAbove }" class="selectable-list-popover">
      <ul class="selectable-list-popover__list">
        @for (language of languages; track language) {
          <li (click)="setLanguage(language)" [class.selected]="getLanguageCode(language) === currentLanguage" class="selectable-list-popover__list__item">
            <div class="icon">
              @if (getLanguageCode(language) === currentLanguage) {
                <app-icon [cssStyle]="{ 'margin-top': '-4px' }" color="var(--orange)" iconName="check" planeIcon="true" size="20px"></app-icon>
              }
            </div>
            <img alt="-" class="lang-flag-icon" src="assets/lang-flags/{{ getLanguageCode(language).toLowerCase() }}.png" />
            {{ language }}
          </li>
        }
      </ul>
    </div>
  }
</div>
